import { useState, type FormEvent } from 'react';
import { LogIn } from 'lucide-react';
import { useT } from '../i18n';
import { describeError } from '../utils/format';
import { useAuth } from './AuthContext';

/** E14-US1 — jediný vstupní bod bez session; žádné „Registrovat se" (kap. 2 — účet vždy založí jiný uživatel). */
export function LoginPage() {
  const t = useT();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
    } catch (caught) {
      setError(describeError(caught, t));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="login-page">
      <form className="card login-page__card" onSubmit={(event) => void submit(event)}>
        <h1>{t('auth.login.title')}</h1>

        {error && <div className="notice notice--error">{error}</div>}

        <div className="field">
          <label htmlFor="login-username">{t('auth.login.usernameLabel')}</label>
          <input
            id="login-username"
            autoFocus
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="login-password">{t('auth.login.passwordLabel')}</label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        <button type="submit" className="primary" disabled={busy || !username || !password}>
          <LogIn size={16} />
          {t('auth.login.submit')}
        </button>
      </form>
    </section>
  );
}
